import React, { Component , Fragment } from "react";
import { Parallax } from "react-parallax";
import {Link} from "react-router-dom";
import Slider from "react-slick";
import { slickDot } from "../page-demo/script";

import Header from "../component/header/Header";
import HeaderTwo from "../component/header/HeaderTwo";
import HeaderThree from "../component/header/HeaderThree";
import HeaderFour from "../component/header/HeaderFour";
import HeaderFive from "../component/header/HeaderFive";
import ServiceList from "../elements/service/ServiceList";
import CounterOne from "../elements/counters/CounterOne";
import Team from "../elements/Team";
import BlogContent from "../elements/blog/BlogContent";
import Brand from "../elements/Brand";
import BrandTwo from "../elements/BrandTwo";
import Footer from "../component/footer/Footer";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Helmet from "../component/common/Helmet";

const list = [
    {
        image: 'image-1',
        category: 'Aplicación móvil - Flutter',
        title: 'Gestión de turismo de la ciudad de Tamaulipas',
        link: 'tamaulipas-app-details'
    },
    {
        image: 'image-8',
        category: 'Aplicación móvil - Flutter',
        title: 'Compra/venta de articulos de segunda mano e inmuebles en América',
        link: 'zerobolas-details'
    },
    {
        image: 'image-3',
        category: 'Aplicación móvil - Flutter',
        title: 'Información de puestos de lotería alrededor de España',
        link: 'fenamix-details'
    },
    {
        image: 'image-2',
        category: 'Página web - Laravel',
        title: 'Gestión de turismo de la ciudad de Tamaulipas',
        link: 'tamaulipas-web-details'
    },
    {
        image: 'image-4',
        category: 'Página web - React',
        title: 'Aplicación de apoyo a estudios en Academia para Oposiciones',
        link: 'apolex-details'
    },
    {
        image: 'image-5',
        category: 'Aplicación móvil - Flutter',
        title: 'Aplicación de gestión de aforo en congreso Fenamix V',
        link: 'fenamix-aforo-details'
    },
    {
        image: 'image-7',
        category: 'Aplicación móvil - Flutter',
        title: 'Aplicación de lista de la compra compartida en tiempo real',
        link: 'go2market-details'
    }
    ,
    {
        image: 'image-9',
        category: 'Red de servidores',
        title: 'Gestión y mantenimiento de servidores para Influencers',
        link: 'cutreland-minecraft-ibai-illojuan-twitch'
    }
]

class Home extends Component {
  
    render(){
        const PostList = BlogContent.slice(0 , 5);
        return(
            <Fragment>
                <Helmet pageTitle="Consultoría Tecnológica" />
                <Header logo="light" />
                {/* Start Slider Area   */}
                <div className="slider-activation slider-creative-agency">
                    <Parallax bgImage={"/assets/images/bg/paralax/bg-image-3-overlay.jpg"} strength={100}>
                        <div className="slide slide-style-2 slider-paralax d-flex align-items-center justify-content-center" key="0">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className={`inner text-center`}>
                                            <h1 className="title theme-gradient">NEARL</h1>
                                            <p className="description">Desarrollamos aplicaciones personalizadas a nivel internacional con las mayores exigencias de calidad y satisfacción de nuestros clientes.</p>
                                            <div className="slide-btn">
                                                <a className="rn-button-style--2 btn-primary-color" href={`/contact`}>
                                                    Contacta con nosotros
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Parallax>
                </div>
                {/* End Slider Area   */}

                {/* Start Service Area  */}
                <div className="service-area creative-service-wrapper ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row creative-service">
                            <div className="col-lg-12">
                                <ServiceList />
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Service Area  */} 

                {/* Start Portfolio Area */}
                <div className="portfolio-area pt--120 pb--140 bg_color--5">
                    <div className="rn-slick-dot">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="section-title service-style--3 text-left mb--15 mb_sm--0">
                                        <h2 className="title">Portfolio</h2>
                                        <p>Un pequeño resumen de los proyectos que hemos realizado tanto para nuestros clientes como por nuestra cuenta.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slick-space-gutter--15 slickdot--20">
                                        <Slider {...slickDot}>
                                            {list.map((value , index) => (
                                                <div className="portfolio" key={index}>
                                                    <div className="thumbnail-inner">
                                                        <div className={`thumbnail ${value.image}`}></div>
                                                        <div className={`bg-blr-image ${value.image}`}></div>
                                                    </div>
                                                    <div className="content">
                                                        <div className="inner">
                                                            <p>{value.category}</p>
                                                            <h4><a href={value.link}>{value.title}</a></h4>
                                                            <div className="portfolio-button">
                                                                <a className="rn-btn" href={value.link}>Ver más</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <Link className="link-overlay" to={value.link}></Link>
                                                </div>
                                            ))}
                                        </Slider>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {/* End Portfolio Area */}

                {/* Start CounterUp Area */}
                <div className="rn-counterup-area pt--140 p pb--110 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h3 className="fontWeight500">Nuestra historia</h3>
                                </div>
                            </div>
                        </div>
                        <CounterOne />
                    </div>
                </div>
                {/* End CounterUp Area */}


                {/* Start Team Area  */}
                <div className="rn-team-area ptb--120 bg_color--5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="section-title service-style--3 text-left mb--25 mb_sm--0">
                                    <h2 className="title">Nuestro equipo</h2>
                                    <p>Los profesionales que van a llevar a cabo tus futuros proyectos.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <Team column="col-lg-4 col-md-6 col-sm-6 col-12" />
                        </div>
                    </div>
                </div>
                {/* End Team Area  */}

                
                {/* Start Brand Area */}
                <div className="rn-team-area pb--120 bg_color--5">
                    <div className="container">
                        <div className="row">
                        <div className="col-lg-6">
                                <div className="section-title service-style--3 text-left mb--25 mb_sm--0">
                                    <h2 className="title">Nuestros clientes</h2>
                                    <p>Principales empresas que han decidido realizar sus proyectos con nosotros.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12 ">
                                <Brand branstyle="branstyle--2" />
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Brand Area */}

                 {/* Start Footer Style  */}
                 <Footer />
                {/* End Footer Style  */}
                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

            </Fragment>
        )
    }
}

export default Home;